import { Component, OnInit, inject, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TableModule } from 'primeng/table';
import { AinPageComponent } from '../../shared/design-system/page.component';
import { AinStateComponent } from '../../shared/design-system/state.component';
import { LocalizationService } from '../../core/localization/localization.service';
import { ProcessInstance, WorkflowApiService } from './workflow-api.service';

@Component({
  standalone: true,
  selector: 'ain-workflow-instances',
  imports: [AinPageComponent, AinStateComponent, TableModule, RouterLink],
  template: `
    <ain-page [title]="t('workflow.instances.title')" [description]="t('workflow.instances.description')">
      @if (loading()) {
        <ain-state type="loading" [title]="t('common.loading')" />
      } @else {
        <p-table [value]="instances()" [paginator]="true" [rows]="10">
          <ng-template pTemplate="header">
            <tr>
              <th>{{ t('columns.reference') }}</th>
              <th>{{ t('columns.status') }}</th>
              <th></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr>
              <td>{{ row.referenceNumber || row.businessKey || row.id }}</td>
              <td>{{ row.status }}</td>
              <td><a [routerLink]="['/workflow/instances', row.id]">{{ t('common.open') }}</a></td>
            </tr>
          </ng-template>
        </p-table>
      }
    </ain-page>
  `,
  styles: [`a { color: var(--ain-color-primary); font-weight: 600; }`]
})
export class WorkflowInstancesComponent implements OnInit {
  private readonly api = inject(WorkflowApiService);
  private readonly localization = inject(LocalizationService);

  readonly instances = signal<ProcessInstance[]>([]);
  readonly loading = signal(true);

  ngOnInit(): void {
    this.api.listInstances().subscribe({
      next: items => {
        this.instances.set(items);
        this.loading.set(false);
      },
      error: () => this.loading.set(false)
    });
  }

  t(key: string): string {
    return this.localization.translate(key);
  }
}
